import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {JsonFilterByPipe} from '../filter.pipe';
import {customFilterPipe} from '../pipes/customFilterMultiKey';
import {ThousandSuffixesPipe} from '../pipes/thousandSuff';
import {SafePipe} from '../pipes/safe';
import { EmojifyModule } from 'angular-emojify';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import {Oauth2Component} from '../components/user_authentication/oauth2/oauth2.component';
import {filterSocialMediaFeeds} from "../pipes/filterSocialMediaFeeds";
import { NgxLinkifyjsModule } from 'ngx-linkifyjs';


import { JwPaginationComponent } from 'jw-angular-pagination';
import {filterBoardsBasedOnRelationsPipe} from "../pipes/filterBoardsBasedOnRelationsPipe";
import {testFilteredBoardListSizePipe} from "../pipes/testFilteredBoardListSizePipe";


import { AngularMaterialModule } from '../angular-material.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

/* import Translate Tool Start */
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient, HttpClientModule, HttpHandler} from '@angular/common/http';
import { SnackbarComponent } from '../components/alerts/snackbar/snackbar.component';
import { MasonryGalleryModule } from 'ngx-masonry-gallery';
// import { NgMasonryGridModule } from 'ng-masonry-grid';
import { LoadDirective } from '../directive/load.directive';
import {ExponentialStrengthPipe} from "../pipes/exponentialStrengthPipe";
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import {VgCoreModule} from '@videogular/ngx-videogular/core';
import {VgControlsModule} from '@videogular/ngx-videogular/controls';
import {VgOverlayPlayModule} from '@videogular/ngx-videogular/overlay-play';
import {VgBufferingModule} from '@videogular/ngx-videogular/buffering';



/* import Translate Tool End */


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
  // return new TranslateHttpLoader(http, './assets/i18n/', '.json');


@NgModule({
  declarations: [
      JsonFilterByPipe,
      customFilterPipe,
      ThousandSuffixesPipe,
      SafePipe,
      filterBoardsBasedOnRelationsPipe,
      testFilteredBoardListSizePipe,
      filterSocialMediaFeeds,
      SnackbarComponent,
      LoadDirective,
      Oauth2Component,
      ExponentialStrengthPipe
  ],
  exports:[
      JsonFilterByPipe,
      PickerModule,
      customFilterPipe,
      ThousandSuffixesPipe,
      InfiniteScrollModule,
      SafePipe,
      EmojifyModule,
      MatBottomSheetModule,
      filterBoardsBasedOnRelationsPipe,
      testFilteredBoardListSizePipe,
      filterSocialMediaFeeds,
      AngularMaterialModule,
      FormsModule,
      ReactiveFormsModule,
      TranslateModule,
      SnackbarComponent,
      MasonryGalleryModule,
      LoadDirective,
      Oauth2Component,
      ExponentialStrengthPipe,
      VgCoreModule,
      VgControlsModule,
      VgOverlayPlayModule,
      VgBufferingModule,
      NgxLinkifyjsModule
  ],

  imports: [
      CommonModule,
      AngularMaterialModule,
      FormsModule,
      EmojifyModule,
      InfiniteScrollModule,
      PickerModule,
      MatBottomSheetModule,
      ReactiveFormsModule,
      TranslateModule,
      MasonryGalleryModule,
      VgCoreModule,
      VgControlsModule,
      VgOverlayPlayModule,
      VgBufferingModule,
      NgxLinkifyjsModule
  ],
  entryComponents: [
    SnackbarComponent
  ]
})

export class ShareModule {
}
